import { createAction } from '@reduxjs/toolkit';

import * as ActionTypes from './actionTypes';

export const loadRefunds = createAction(ActionTypes.LOAD_REFUNDS.BASE);
